import AmiB2BLogoDesktop from "./AmiB2BLogoDesktop";

export default AmiB2BLogoDesktop;
